import { Avatar, Space, Tag } from 'antd';
import { getImageUrl } from 'utils/tools';
import { useTranslation } from 'react-i18next';
// import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { DynamicObjectType } from 'types/commons';

interface IVariantNameItemTypes {
  item?: DynamicObjectType;
  productAttributesKeyById?: DynamicObjectType;
  onDeleteItem?: (value) => void;
  // onChangeChooseGift?: (value) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  productAttributesObjKeyById?: any;
}

function VariantNameItem({
  item,
  // onChangeChooseGift,
  productAttributesObjKeyById,
}: IVariantNameItemTypes) {
  const { t } = useTranslation();
  const currentAttributeValues = item?.listAttributeValueIds?.map(
    (id) => productAttributesObjKeyById?.[id],
  );

  return (
    <Space direction="vertical">
      <Space size={15}>
        <Avatar
          src={getImageUrl(
            item?.variant?.thumbnail ||
              item?.product?.thumbnail ||
              item?.thumbnail ||
              item?.variant?.medias?.find(
                (m) =>
                  m?.entityType === 'VARIANT' && m?.type === 'main_thumbnail',
              )?.media?.url,
          )}
          shape="square"
          size={40}
        />
        <div>
          <Space direction="horizontal" size={0}>
            {item?.isGift && <Tag color="red">{t('common.text.gift')}</Tag>}
            <div className="fw-500 text-title-gray text-sm">{item?.name}</div>
          </Space>
          <div className="text-sm">
            {currentAttributeValues?.map((e, idx) => (
              <Tag key={String(idx)} color="blue">
                {e?.value}
              </Tag>
            ))}
          </div>
          {/* <div className="text-subtitle-gray text-sm fw-400">
            {flatMap(
              item?.attributeValues?.map((e) =>
                e?.map((i) => i?.detail?.[0]?.name),
              ),
            ).join('/')}
          </div> */}
          {item?.variantText && (
            <div className="text-subtitle-gray text-[14px] fw-400">
              {item?.variantText}
            </div>
          )}
          {item?.sku ||
            (item?.variantSku && (
              <div className="text-[14px] fw-400">{`SKU: ${item?.sku || item?.variantSku}`}</div>
            ))}
        </div>
      </Space>
      {/* {item?.gift?.sku && (
        <>
          <Button
            type="dashed"
            icon={
              expandedRowKeys?.includes(item.id) ? (
                <MinusOutlined />
              ) : (
                <PlusOutlined />
              )
            }
            onClick={() => onChangeChooseGift(item.id)}
          >
            {`${t('orders.chooseGift')}`}
          </Button>

          <Space size={15}>
            <Avatar
              src={getImageUrl(item.gift.thumbnail)}
              shape="square"
              size={40}
            />
            <div>
              <div className="fw-500">{item.gift.sku}</div>
              <div>{item.gift?.colorDetail}</div>
            </div>
          </Space>
        </>
      )} */}
    </Space>
  );
}

export default VariantNameItem;
